import styled from 'styled-components'
import Flex from 'components/reusable/flex'
import Image from 'components/reusable/image'
import Button from 'components/reusable/button'
import { colors } from 'helpers/colors'
import { cardBoxShadow } from 'helpers/style'

export const ModalWrapper = styled.div`
  display: flex;
  border-radius: 24px;
  overflow: hidden;
  ${cardBoxShadow}
  width: 80vw;
  max-width: 900px;
  max-height: 90vh;
  
  @media (max-width: 768px) {
    width: 100vw;
    flex-direction: column;
    max-height: 95vh;
    border-radius: 24px 24px 0 0;
  }
`

export const ImageSection = styled.div`
  position: relative;
  width: 45%;
  min-height: 450px;
  flex-shrink: 0;


  @media (min-width: 769px) and (max-width: 1200px) {
    width: 300px;
    
    img {
      object-position: center;
    }
  }
  
  @media (max-width: 768px) {
    width: 100%;
    min-height: 180px;
    height: 180px;

    img {
      object-position: center;
    } 
  }
`

export const BannerImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const ContentSection = styled(Flex)`
  flex: 1;
  padding: 32px;
  background: ${colors.light};
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`

export const CloseButton = styled(Button)`
  position: absolute;
  right: 16px;
  top: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${colors.light};
  ${cardBoxShadow}
  z-index: 2;
  
  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    right: 12px;
    top: 12px;
  }
`
